module.exports = __webpack_public_path__ + "static/media/notebook-purple.4de662ae.svg";